import axios from 'axios';
import { useCallback } from 'react';

import { baseUrl } from '../helpers/urls';
import { useCurrentUser } from '../contexts/CurrentUser.context';

const useStatistics = () => {

  const { token } = useCurrentUser();

  const getStatistics = useCallback(async ({ walletCode, start, end }) => {
    const response = await axios({
      method: 'GET',
      url: `${baseUrl}/wallets/${walletCode}/statistics`,
      params: { start, end },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });

    return response.data;
  }, [token]);

  return {
    getStatistics,
  };
};

export default useStatistics;
